import { render, staticRenderFns } from "./QuoteBuilderLabourItem.vue?vue&type=template&id=a82136ee"
import script from "./QuoteBuilderLabourItem.vue?vue&type=script&lang=js"
export * from "./QuoteBuilderLabourItem.vue?vue&type=script&lang=js"
import style0 from "./QuoteBuilderLabourItem.vue?vue&type=style&index=0&id=a82136ee&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a82136ee')) {
      api.createRecord('a82136ee', component.options)
    } else {
      api.reload('a82136ee', component.options)
    }
    module.hot.accept("./QuoteBuilderLabourItem.vue?vue&type=template&id=a82136ee", function () {
      api.rerender('a82136ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/quoteBuilder/ItemTypeComponents/quoteBuilderLabour/QuoteBuilderLabourItem.vue"
export default component.exports